// import Vue from 'vue'

export const SET_FIELD = (state, { key, value }) => key && (state[key] = value)

export const SET_STATE = (state, newData) => Object.assign(state, newData)

export const REMOVE_EXTERNAL_GIFT_CARD_BY_ID = (state, { giftCardID }) =>
  delete state.selectedExternalGiftCardForCheckout[giftCardID]
